import React from 'react';
import * as PropTypes from 'prop-types';
import SendIcon from '@material-ui/icons/Send';
import Button from '../Button'; // Using the project's standard MUI-based Button
import LoadingSpinner from '../../../../Components/Helpers/LoadingSpinner';
import { connect } from 'react-redux';
import { loadingIsLoadingSelector } from '../../../../Redux/loading/selectors';

const SendFranchisePartnerAccountingExportButton = ({ id, isLoading, children, disabled, ...props }) => {
    return (
        <Button
            {...props}
            startIcon={<SendIcon />}
            disabled={disabled || isLoading}
            data-cy="submit"
        >
            {isLoading ? <LoadingSpinner size={20} /> : children}
        </Button>
    );
};

SendFranchisePartnerAccountingExportButton.propTypes = {
    children: PropTypes.node.isRequired,
    isLoading: PropTypes.bool.isRequired,
    id: PropTypes.string,
    disabled: PropTypes.bool,
    // Ensure these props are documented for clarity as they are passed to the underlying button
    onClick: PropTypes.func,
    type: PropTypes.string,
    name: PropTypes.string,
};

SendFranchisePartnerAccountingExportButton.defaultProps = {
    disabled: false,
    id: null,
};

export default connect((state, { id, isLoading }) => ({
    isLoading: isLoading !== undefined ? isLoading : loadingIsLoadingSelector(state, id),
}))(SendFranchisePartnerAccountingExportButton);